import {
    GET_PAYMENT_DATA_ERROR,
    GET_PAYMENT_DATA_REQUEST,
    GET_PAYMENT_DATA_SUCCESS,
} from "../actions/types"
export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {

        case GET_PAYMENT_DATA_REQUEST:
            return {
                loading: true,
            };
        case GET_PAYMENT_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GET_PAYMENT_DATA_ERROR:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
}